import _ from 'lodash'
import Validate from "./validate";
import moment from 'moment'
export default {
    //获取当前用户信息
    currentUser: state => {
        return state.user;
    },
    //获取主内容区dom对象
    getMainDom: () => {
        return document.getElementById('main-content');
    },
    //设置或获取url记录
    storageCacheUrl: () => url => {
        let name = 'webchecker-url';
        if (typeof url !== 'undefined') {
            window.localStorage[name] = url;
        } else {
            return window.localStorage[name] || '';
        }
    },
    // url格式化
    urlFormat: () => (url, type) => {
        if (Validate.validateUrl(url)) {
            let text = (url || '').replace(/https?:\/\//i, '').replace(/\s/g, '');
            if (!type || type === 1) {
                let regexp = text.match(/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/);
                return (regexp || [''])[0];
            } else if (type === 2) {
                return text;
            } else {
                return text;
            }
        } else {
            return url;
        }
    },
    // url验证
    urlValid: () => url => {
        let data = {
            error: false,
            url
        };
        if (!url) {
            data.error = '请输入网址';
        }
        if (!Validate.validateUrl(url)) {
            data.error = '请输入正确的网址';
        }
        if (url.split('.').length === 2 && !/^https?:\/\//i.test(url) && !/^www\./i.test(url)) {
            data.url = 'www.' + url;
        }
        return data;
    },
    //秒转换为时分秒
    secondToDate: () => (value, chars) => {
        value = parseInt(value);
        let timeArray = [
            {name: '小时', value: Math.floor(value / 3600)},
            {name: '分钟', value: Math.floor(value / 60 % 60)},
            {name: '秒', value: Math.floor(value % 60)}
        ], result = '';
        timeArray.forEach((item, index) => {
            let name = chars || item.name;
            if (chars && index === timeArray.length - 1) {
                name = ''
            }
            if (item.value > 0 || !!result) result += _.padStart(item.value, 2, '0') + name;
        });
        return result;
    },
    //随机长度的字符串
    getRandomWord: () => () => {
        let code = '';
        let arr = [
            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
            'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
        ];
        let date = new Date().getTime().toString();
        for (let i = 0; i < date.length; i ++) {
            let number = +date[i];
            code += arr[_.random(0, 61)] + arr[number + _.random(0, 61 - number)];
        }
        return code;
    },
    // 获取格式化指定长度的数值
    getNumber: () => (number, length) => {
        return _.padStart(number, length, '0');
    },
    //判断是否为会员
    isVip: state=>{
        if(state.user.expirationDateM||state.user.expirationDateY){
            if(state.user.expirationDateY){
                if(moment(state.user.expirationDateM).diff( moment(), 'd' )>=0){
                    return 'vip-year'
                }
                else{
                    if(moment(state.user.expirationDateM).diff( moment(), 'd' )>=0){
                        return 'vip-month'
                    }else{
                        return 'no-vip'
                    }
                }
            }else{
                if(moment(state.user.expirationDateM).diff( moment(), 'd' )>=0){
                    return 'vip-month'
                }else{
                    return 'no-vip'
                }
            }

        }
        else{
            return 'no-vip'
        }
    },
};



// WEBPACK FOOTER //
// ./app/store/getters.js